// by default all the guest routes are filtered
export const generateRoutesFromConfigs = (configs) => {
  let routes = [];
  configs.forEach((config) => {
      routes = [...routes, ...config.routes];
  });
  return routes;
};
